<template>
  <div ref="radarEchart" style="height: 300px"></div>
</template>

<script>
export default {
  name: "radarSimple",
  mounted() {
    this.initEcharts();
  },
  methods: {
    initEcharts() {
      let chartDom = this.$refs.radarEchart;
      let myChart = this.$echarts.init(chartDom);
      this.myChart = myChart;

      let option = {
        title: {
          text: "分题成绩统计",
          left: "center",
        },
        tooltip: {
          trigger: "item",
        },
        legend: [
          {
            type: "scroll",
            bottom: 10,
            data: ["张三", "李四"],
          },
        ],
        radar: {
          indicator: [
            { name: "题目1", max: 100 },
            { name: "题目2", max: 100 },
            { name: "题目3", max: 100 },
            { name: "题目4", max: 100 },
            { name: "题目5", max: 100 },
          ],
          radius: 80,
        },
        series: [
          {
            name: "学员报告题目得分情况",
            type: "radar",
            // areaStyle: {},
            data: [
              {
                value: [0, 0, 0, 0, 0],
                name: "学员1",
              },
            ],
          },
        ],
      };
      myChart.setOption(option);
    },
    refreshData(indicator = [], data = []) {
      try {
        let option = this.myChart.getOption();
        let legendData = [];
        data.map(({ name }) => {
          legendData.push(name);
        });
        option.legend[0].data = legendData;
        option.radar[0].indicator = indicator;
        option.series[0].data = data;
        this.myChart.setOption(option);
      } catch (error) {
        console.warn(error);
      }
    },
  },
};
</script>